/**
 *  @class
 *  @function Timeline
 */

if (!customElements.get('time-line')) {
	class Timeline extends HTMLElement {
		constructor() {
			super();
			this.id = this.dataset.id;
			this.scroller = this.querySelector('.timeline--scroll-container');
			this.animations_enabled = document.body.classList.contains('animations-true') && typeof gsap !== 'undefined';
			this.scrollSet = false;
			this.items = this.querySelectorAll('.timeline--slide');
			this.labels = this.querySelectorAll('.timeline--scroll-pagination li');

			if (this.animations_enabled) {
				this.scrollSet = gsap.quickSetter('#time-line-progress-' + this.id, "scaleX");
			}
		}
		connectedCallback() {
			const _this = this;
			if (this.animations_enabled) {
				_this.scroller.addEventListener('scroll', () => this.onScroll());
			}

			_this.labels.forEach((item, i) => {
				_this.setLabelPosition(item);
			});
		}
		setLabelPosition(item) {
			let contentWidth = this.scroller.querySelector('.timeline--scroll-inner').offsetWidth,
				arr = Array.prototype.slice.call(this.labels),
				i = arr.indexOf(item),
				itemWidth = this.items[i].offsetWidth;

			item.style.flex = (itemWidth / contentWidth);
		}
		onScroll() {
	const scrollLeft = this.scroller.scrollLeft;
	const scrollerWidth = this.scroller.offsetWidth;
	const contentWidth = this.scroller.querySelector('.timeline--scroll-inner').offsetWidth;
	const maxScroll = Math.max(0, contentWidth - scrollerWidth);
	const scrollPercent = maxScroll ? scrollLeft / maxScroll : 0;

	// Same value GSAP applies as scaleX(transform) — avoid parsing matrix if you already have it
	const scaleX = scrollPercent;

	if (this.animations_enabled && this.scrollSet) {
		this.scrollSet(scaleX);
	}

	const pagination = this.querySelector('.timeline--scroll-pagination');
	const progressBar = this.querySelector('.timeline--scroll-progress');
	if (!pagination || !progressBar || !this.labels.length) return;

	const barRect = progressBar.getBoundingClientRect();
	// Right edge of the filled region (origin left + scale)
	const progressTipX = barRect.left + scaleX * barRect.width;

	let activeIndex = -1;
	this.labels.forEach((li, i) => {
		const dot = li.querySelector('.timeline--dot');
		if (!dot) return;
		const dotRect = dot.getBoundingClientRect();
		const dotCenterX = dotRect.left + dotRect.width / 2;
		if (progressTipX >= dotCenterX) activeIndex = i;
	});
	if (activeIndex < 0) activeIndex = 0;

	this.labels.forEach((li, i) => {
		li.classList.toggle('is-active', i <= activeIndex);
	});
}
	}
	customElements.define('time-line', Timeline);
}
